export default __webpack_public_path__ + "static/media/PR.STREAK.SIX_WEEKS.023a2680.jpg";